import React from 'react';
import { useDisplayPreferences } from '../../displayPreferences-context';
import { BuildingBaseLayerAllZoom } from './building-base-layer-all-zoom';
export function BoroughLabelLayer({}) {
    const { borough } = useDisplayPreferences();
    if (borough == "enabled") {
        return React.createElement(BuildingBaseLayerAllZoom, { theme: "boroughs" });
    }
    else {
        return React.createElement(React.Fragment, null);
    }
}
